<template>
    <section>
        <table class="table fading">
            <thead>
            <tr>
                <td></td>
                <td>Account</td>
                <td v-if="type === SENTIMENT">Tweets</td>
                <td v-if="type === SENTIMENT">Avg. sentiment</td>
                <td v-if="type === MENTIONED">Mentioned</td>
                <td v-if="type === BIGGEST">Tweeted</td>
                <td v-if="type === BIGGEST">Followers</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="account in accounts">
                <td>
                    <img :src="account.profile_picture || 'https://abs.twimg.com/sticky/default_profile_images/default_profile_normal.png'" class="img-circle profile-picture">
                </td>
                <td>
                    <a :href="'https://twitter.com/'+(account.user_name || account.screen_name)" target="_blank">@{{account.user_name || account.screen_name}}</a>
                </td>
                <td v-if="type === SENTIMENT">
                    {{account.tweets}}
                </td>
                <td v-if="type === SENTIMENT" :class="{'text-success': account.sentiment > 0, 'text-danger': account.sentiment < 0}">
                    {{account.sentiment | round(2) }}
                </td>
                <td v-if="type === MENTIONED">
                    {{account.count}}x
                </td>
                <td v-if="type === BIGGEST">
                    {{account.tweets}}x
                </td>
                <td v-if="type === BIGGEST">
                    {{account.followers}}
                </td>

            </tr>
            <tr v-for="i in remain" class="dummy-row">
                <td></td>
                <td></td>
                <td v-if="type === SENTIMENT"></td>
                <td v-if="type === SENTIMENT"></td>
                <td v-if="type === MENTIONED"></td>
                <td v-if="type === BIGGEST"></td>
                <td v-if="type === BIGGEST"></td>
            </tr>
            </tbody>
        </table>
    </section>
</template>

<script>
    const SENTIMENT = 'sentiment'
    const BIGGEST = 'biggest'
    const MENTIONED = 'mentioned'

    export default {
        name: 'Accounts',
        props: ['accounts', 'type'],
        data () {
            return {
                SENTIMENT,
                BIGGEST,
                MENTIONED
            }
        },
        computed: {
            remain () {
                return 5 - this.accounts.length
            }
        }
    }
</script>

<style scoped>
    .dummy-row {
        height: 62px;
    }
    .profile-picture {
        width: 32px;
    }
    table.table td {
        padding: 6px
    }
</style>


// WEBPACK FOOTER //
// src/components/Accounts.vue